<template lang="pug">
.container
  .content
    img(src="/static/empty.svg")
    .hint
      | {{content}}
</template>

<script>
export default {
  name: 'EmptyPage',
  data() {
    return {
    };
  },
  props: {
    content: {
      default: '暂无内容...',
    },
  },
};
</script>

<style lang="stylus" scoped>
.container
  width: 100%
  display: flex
  justify-content: center
  align-items: center
  .content
    width: 200px
    display: flex
    flex-direction: column
    .hint
      text-align: center
      color: #888
      font-size: 17px
      padding-top: 30px
</style>




// WEBPACK FOOTER //
// EmptyPage.vue?0ac9451a